import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "../../../redux/actions/menuActions";
import SectorsContainer from "../../../containers/metier/sectors/SectorsContainer";
import MenuAdmin from "../Menu";

class Modeles extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("imports");
    this.props.setMenuLeftContent(MenuAdmin);
    this.props.setMenuLeftIndex("secto");
  }
  render() {
    return <SectorsContainer {...this.props} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentClientLabel: (state.currentClient || {}).label
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Modeles);



// WEBPACK FOOTER //
// src/pages/imports/imports/Secto.js